import { useTranslation } from '@/i18n';
import { ApPayeeDetail as ApPayeeModel } from 'ap-openapi';
import { useMemo } from 'react';

export function useUtilizePastDetails(selectedPayee?: ApPayeeModel) {
  const { t } = useTranslation();

  const hasSelectedPayee = useMemo(() => {
    return !!selectedPayee && !!selectedPayee.code;
  }, [selectedPayee]);

  const tooltipTitle = useMemo(() => {
    return hasSelectedPayee ? '' : t('payment_past_details_select_payee');
  }, [hasSelectedPayee, t]);

  return {
    tooltipTitle,
    hasSelectedPayee,
  };
}
